/**
 * useShortcutEdit.js — 사이드바 편집 모드 hook (2026-04-27 신규)
 *
 * 모바일 헤더 바로가기 (최대 5개) 등록을 위한 편집 모드 상태 관리.
 *
 * 사용:
 *   const { editMode, selections, startEdit, toggle, save, cancel } = useShortcutEdit(initial, onSave);
 *
 * 동작:
 *   - startEdit(): 현재 저장된 shortcuts 로 selections 초기화 + editMode=true
 *   - toggle(path): selections Set 에 add/remove (size === MAX 시 추가 차단)
 *   - save(): onSave(Array.from(selections)) + editMode=false
 *   - cancel(): editMode=false (selections 변경 분 폐기)
 */
import { useState } from 'react';
import { MAX_SHORTCUTS } from './shortcutHelpers';

export function useShortcutEdit(initialShortcuts, onSave) {
  const [editMode, setEditMode] = useState(false);
  const [selections, setSelections] = useState(() => new Set(initialShortcuts || []));

  function startEdit() {
    // 편집 진입 시 현재 저장값으로 selections 동기화 (이전 변경분 폐기)
    setSelections(new Set(initialShortcuts || []));
    setEditMode(true);
  }

  function toggle(path) {
    setSelections((prev) => {
      const next = new Set(prev);
      if (next.has(path)) next.delete(path);
      else if (next.size < MAX_SHORTCUTS) next.add(path);
      // size === MAX_SHORTCUTS 시 추가 무시
      return next;
    });
  }

  function save() {
    if (typeof onSave === 'function') onSave(Array.from(selections));
    setEditMode(false);
  }

  function cancel() {
    setEditMode(false);
  }

  return { editMode, selections, startEdit, toggle, save, cancel };
}
